var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_2153_16700)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 16.5C26.0359 16.5 25.5908 16.6844 25.2626 17.0126C24.9344 17.3408 24.75 17.7859 24.75 18.25V25.25H17.75C17.2859 25.25 16.8408 25.4344 16.5126 25.7626C16.1844 26.0908 16 26.5359 16 27V34C16 34.4641 16.1844 34.9092 16.5126 35.2374C16.8408 35.5656 17.2859 35.75 17.75 35.75H24.75V42.75C24.75 43.2141 24.9344 43.6592 25.2626 43.9874C25.5908 44.3156 26.0359 44.5 26.5 44.5H33.5C33.9641 44.5 34.4092 44.3156 34.7374 43.9874C35.0656 43.6592 35.25 43.2141 35.25 42.75V35.75H42.25C42.7141 35.75 43.1592 35.5656 43.4874 35.2374C43.8156 34.9092 44 34.4641 44 34V27C44 26.5359 43.8156 26.0908 43.4874 25.7626C43.1592 25.4344 42.7141 25.25 42.25 25.25H35.25V18.25C35.25 17.7859 35.0656 17.3408 34.7374 17.0126C34.4092 16.6844 33.9641 16.5 33.5 16.5H26.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2153_16700",
    x1: 8,
    y1: 8.5,
    x2: 45.5,
    y2: 55.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C52121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09191"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.0ad0e8e17bbec36d7eb3e8dc63c63c72.svg";
export { ForwardRef as ReactComponent };